// The דוח ליזם symbology, keyed on HB_TYPE and taken from the ArcGIS service
// HB/HB_GLOBAL_POINTS_LINES_POLYGONS_A. Codes 4 and 6 carry no symbol there.
export const HB_TYPE_COLORS: { [hbType: number]: number[] } = {
  1: [161, 246, 9],    // תעלת בדיקה ללא ממצאים
  2: [252, 3, 233],    // תוואי שטח חישוף
  3: [255, 0, 0],      // תעלת בדיקה עם ממצא ארכיאולוגי
  5: [249, 150, 0],    // תוואי שטח שלא נבדק
  7: [135, 130, 130],  // אחר
  99: [0, 92, 230],    // לא מוגדר לא בשימוש
};

// The map legend, one entry per symbolised HB_TYPE, in the design's order.
export const HB_LEGEND: { hbType: number; label: string }[] = [
  { hbType: 3, label: 'iaa.app.hbSection.legend.archaeologicalFind' },
  { hbType: 2, label: 'iaa.app.hbSection.legend.exposure' },
  { hbType: 1, label: 'iaa.app.hbSection.legend.testTrench' },
  { hbType: 5, label: 'iaa.app.hbSection.legend.notExamined' },
  { hbType: 99, label: 'iaa.app.hbSection.legend.undefined' },
  { hbType: 7, label: 'iaa.app.hbSection.legend.other' },
];

export const HB_DEFAULT_COLOR = [130, 130, 130];

export const HB_SECTION_BOUNDARY_COLOR = [0, 0, 0];

// Outline for the finding a table row has selected.
export const HB_HIGHLIGHT_OUTLINE = [0, 76, 146];

// The ArcGIS renderer's own sizes.
export const HB_POINT_SIZE = 11.5;
export const HB_LINE_WIDTH = 2.5;

export function hbTypeColor(hbType: number | null): number[] {
  return (hbType !== null && HB_TYPE_COLORS[hbType]) || HB_DEFAULT_COLOR;
}

// Bounding-box area of a WKT geometry, used only to order shapes largest-first on the
// map; a point yields 0 and so draws last, on top of everything containing it.
export function extentArea(wkt: string): number {
  const numbers = wkt.match(/-?\d+(\.\d+)?/g);
  if (!numbers || numbers.length < 4) {
    return 0;
  }
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (let i = 0; i + 1 < numbers.length; i += 2) {
    const x = parseFloat(numbers[i]);
    const y = parseFloat(numbers[i + 1]);
    minX = Math.min(minX, x); maxX = Math.max(maxX, x);
    minY = Math.min(minY, y); maxY = Math.max(maxY, y);
  }
  return (maxX - minX) * (maxY - minY);
}
